import React from 'react';
import { log } from '../../loggers/Logger';
import RumClient from '../../monitoring/RumClient';
import NotFound from '../common/NotFound';
import { InvalidUrlError } from '../InvalidUrlError';
import { Box, Container, Grid, Header } from '@amzn/awsui-components-core';

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<any, State> {
  public static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }
  private rumClient;

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.rumClient = RumClient.create();
    this.state = { hasError: false };
  }

  // @ts-expect-error TS7006 - strict migration
  public componentDidCatch(error, info) {
    log.error({
      error,
      type: 'ERROR',
    });
    this.rumClient?.recordError(error);
  }

  public render() {
    const { hasError, error } = this.state;
    if (hasError) {
      if (error instanceof InvalidUrlError) {
        return <NotFound />;
      }

      return (
        <Grid gridDefinition={[{ colspan: 10, offset: { m: 1 } }]}>
          <Box margin={{ top: 'xxl' }}>
            <Container header={<Header variant="h3">Error</Header>}>
              An error occurred that prevented the current view to render correctly. Please try
              again by refreshing your browser. In case the error persists please report the problem
              using the "Submit Issue" link in the header bar.
            </Container>
          </Box>
        </Grid>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
